<template>
  <container :class="['page-wrapper', 'mb-8']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="8" xs24 v-for="item in 3" :key="`${item}-16/9`">
        <card align="center">
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">16/9</card-title>
          <card-text v-aspect-ratio="16/9" />
        </card>
      </flex-col>
      <flex-col :span="6" xs24 v-for="item in 4" :key="`${item}-1/1`">
        <card align="center">
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">1/1</card-title>
          <card-text v-aspect-ratio="1/1" />
        </card>
      </flex-col>
      <flex-col :span="4" xs24 v-for="item in 6" :key="`${item}-4/3`">
        <card align="center">
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">4/3</card-title>
          <card-text v-aspect-ratio="4/3" />
        </card>
      </flex-col>
      <flex-col :span="2" sm12 xs24 v-for="item in 12" :key="`${item}-3/2`">
        <card align="center">
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">3/2</card-title>
          <card-text v-aspect-ratio="3/2" />
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageAspectRatio'
}
</script>



// WEBPACK FOOTER //
// src/pages/directives/aspect-ratio.vue